var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.523,
    height: 15.523,
    viewBox: "0 0 15.523 15.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-stop-circle",
    "data-name": "Icon awesome-stop-circle",
    d: "M8.324.563a7.762,7.762,0,1,0,7.762,7.762A7.76,7.76,0,0,0,8.324.563Zm3,10.265a.5.5,0,0,1-.5.5H5.82a.5.5,0,0,1-.5-.5V5.82a.5.5,0,0,1,.5-.5h5.008a.5.5,0,0,1,.5.5Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#f05b40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircle);
export default __webpack_public_path__ + "static/media/stop-circle.c042e91a2844bbcc7a86f055137bea20.svg";
export { ForwardRef as ReactComponent };